import { PostsState } from './posts-state';

export const INITIAL_POSTS_STATE: PostsState = { nextOffset: 0, posts: {} };
